(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-yourself"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLevelGallery = (root) => {
      if (!root || root.dataset.levelGalleryReady === 'true') return;

      const track = root.querySelector('[data-level-track]');
      const slides = [...root.querySelectorAll('[data-level-slide]')];
      const dots = [...root.querySelectorAll('[data-level-dot]')];
      const prev = root.querySelector('[data-level-prev]');
      const next = root.querySelector('[data-level-next]');

      if (!track || slides.length === 0) return;

      let index = 0;

      const show = (targetIndex) => {
        index = (targetIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      prev?.addEventListener('click', () => show(index - 1));
      next?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => show(Number(dot.dataset.levelDot)));
      });

      let touchStartX = null;
      root.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      root.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const difference = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(difference) > 45) show(index + (difference < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });

      root.dataset.levelGalleryReady = 'true';
      show(0);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-level-gallery]').forEach(initLevelGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
